<section class="select-wrapper">
  <section class="inner-sec" [ngClass]="{'control-disabled': disabled}" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    @for (item of options; track trackByCheckedCheckList($index, item)) {
      @if (item.checked) {
        <span class="selected-item">
          <span class="text-item">
            {{item.text}}
          </span>
          <button [disabled]="disabled" (click)="uncheckSingleCheckBox(item)" class="icon-btn remove-btn" id="_remove_item_Btn_{{$index}}"
            title="remove item" type="button" role="button">
            <img src="assets/images/close.png" alt="remove icon">
          </button>
        </span>
      }
    }
    <span class=" separator"></span>
    <button [disabled]="disabled" (click)="onUnCheckAllClick($event)" class="icon-btn remove-all-btn" id="_remove_all_btn"
      title="remove all items" type="button" role="button">
      <img src="assets/images/close.png" alt="remove icon">
    </button>
    <button [disabled]="disabled" (click)="isOpen = !isOpen" class="icon-btn show-items-btn" title="show items" id="_show_items_btn"
      type="button" role="button">
      <img src="assets/images/downarrow.png" alt="open dropdown icon">
    </button>
  </section>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
    <section #popoverWrapper class="popover__wrapper">

      <div class="select-all">
        <button (click)="onUnCheckAllClick($event)" class="icon-btn remove-all-btn" title="remove all items"
          type="button" role="button" id="_popover_remove_all_btn">
          <img src="assets/images/close.png" alt="remove icon">
        </button>
        <button [disabled]="disabled" (click)="isOpen = !isOpen" class="icon-btn show-items-btn"
          title="show items" type="button" role="button" id="_popover_show_items_btn">
          <img class="close-up" src="assets/images/downarrow.png" alt="close icon">
        </button>
        <span class="separator"></span>
        <label (click)="toggleSelectAll(true)" id="_toggle_select_all_label">Select All</label>
      </div>
      <section class="checkbox-list">
        @for (item of options; track trackByCheckList($index, item)) {
          <label class="checkbox-item"
            [ngClass]="{ 'checked' :  item.checked}">
            <input type="checkbox" (change)="onCheckboxChange(item)" [checked]="item.checked" id="_checkbox_input_{{$index}}" />
            <span>{{item.text}}</span>
          </label>
        }
      </section>
    </section>
  </ng-template>
</section>